// extracted by mini-css-extract-plugin
export default {"wrapper":"TweetActorName_wrapper__oTxHv","fullname":"TweetActorName_fullname__vV2j7","username":"TweetActorName_username__h5Y5M","tweet-date":"TweetActorName_tweet-date__fY02F"};